module.exports = __webpack_public_path__ + "img/kehu_shanhejianshe.58e7c546.png";